import React, { useState } from 'react';

const GetLocalStorage = () => {
  useState(() => {
    const PERMITTED_DOMAIN = 'https://accounts.okumaplatformu.com';
    const messageReceived = (event) => {
      if (event.origin.startsWith(PERMITTED_DOMAIN)) {
        if (event.data) {
          const key = Object.keys(event.data)[0];
          const value = event.data[key];
          if (value !== '') {
            localStorage.setItem(key, value);
          } else {
            localStorage.removeItem(key);
          }
        }
      }
    };
    window.addEventListener('message', messageReceived);

    /* istanbul ignore next -- useState initializer return is never invoked by React (no cleanup semantics); only useEffect would call this */
    return () => {
      window.removeEventListener('message', messageReceived);
    };
  });
  return <></>;
};

export default GetLocalStorage;
